import {Divider, Row} from 'antd'
import React from 'react'
import {GeneralProjectInfoForm} from '../generalProjectInfoForm/generalProjectInfoForm'
import {useIntl} from 'react-intl'

export function NewProject() {
  const intl = useIntl()
  return (
    <div>
      <Row>
        <div>
          <h2 style={{display: 'inline'}}>{intl.formatMessage({id: 'creatingOfNewProject'})}</h2>
        </div>
        <Divider style={{height: 'auto'}}></Divider>
        {/* <div>Steps</div> */}
      </Row>

      <Row>
        <GeneralProjectInfoForm project={null} />
      </Row>
    </div>
  )
}
